<div class="well">
    <h2><i class="fa fa-sitemap fa-lg"></i> Create Site</h2><br>

    <div class="row">
        <div class="col-lg-12">
            <label class="control-label">Master Community</label>
            <p-dropdown [options]="anaplanFeasyOptions" placeholder="Select an Anaplan Community..."
                [disabled]="isLoading" [filter]="true" filterBy="label" appendTo="body" scrollHeight="400px"
                [style]="{ width: '100%' }" styleClass="w-100"
                (onChange)="onMasterCommChange($event.value)"></p-dropdown>
        </div>
        <br />
        <div class="col-lg-6">
            <button type="button" class="btn btn-primary" (click)="onCreateSiteClick()"
                [disabled]="enableCreateSite === false"><i class="fa fa-align-left"></i> Create
                Site</button>&nbsp;&nbsp;
            <input type="checkbox" id="import" text="importdata"
                (change)="checkImport($event.target.checked)" />&nbsp;Include "Import Anaplan Data"&nbsp;&nbsp;
            <span *ngIf="isLoading"><img width="30" height="30" src="../../assets/loading_spinner-alternate.gif"
                    alt="Loading..."></span>
        </div>

        <div class="col-lg-6 text-end">
            <button type="button" class="btn btn-secondary" (click)="onImportAnaplanCommunitiesClick()"
                [disabled]="disableImportAnaplanCommunities === true"><i class="fa fa-align-right"></i> Import Anaplan
                Communities</button>
        </div>

        <div class="col-lg-12">
            <ng-container *ngIf="showNotImported">
                <div><i>Data not yet imported for this Master Community</i></div>
            </ng-container>

            <ng-container *ngIf="showImported">
                <div><i>Last Imported: {{ dateImported | date: 'short' }}</i></div>
            </ng-container>

            <ng-container *ngIf="showSiteExists">
                <div><i>Site already exists on SharePoint</i></div>
            </ng-container>

            <ng-container *ngIf="createJobErrorMessage != ''">
                <div>{{createJobErrorMessage}}</div>
            </ng-container>
        </div>
    </div>
</div>

<p-toast position="top-right"></p-toast>

<app-job-queue-list></app-job-queue-list>